import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import _ from "lodash";

const Layout = ({ title, tabs, children, headerChildren }) => {
  return (
    <div className="admin-layout">
      <div className="admin-header">{title}</div>
      {_.isArray(tabs) && tabs.length > 0 && (
        <div className="admin-sub-header">
          <div className="admin-sub-header-tabs">
            {tabs?.map((tab, i) => {
              return (
                <NavLink
                  key={`admin-tab-${i}`}
                  className={({ isActive }) =>
                    `admin-sub-header-tabs-tab ${
                      isActive ? "admin-sub-header-tabs-tab--active" : ""
                    }`
                  }
                  to={tab.path}
                >
                  {tab.title}
                </NavLink>
              );
            })}
          </div>
          <div className="admin-sub-header-children">{headerChildren}</div>
        </div>
      )}
      <div className="admin-layout-content">{children}</div>
    </div>
  );
};

Layout.propTypes = {
  title: PropTypes.string,
  tabs: PropTypes.array,
  headerChildren: PropTypes.element,
};

Layout.defaultProps = {
  title: "",
  tabs: [],
  headerChildren: <></>,
};

export default Layout;
